import {  sublocalityColors } from "../themes/mobiliTheme";

const colors = [
  '#6FBF99',
  '#B4BF6F',
  '#D9DFE2',
  '#6F8FBF',
  '#8B6FBF',
  '#F2CBD3',
  '#D943FF',
  '#82FF87',
  '#4361FF',
  '#9C1A35',
  '#003059',
];

export function generateColor(name: string) {
  // if (name.length !== 3) {
  //   return 'default';
  // }


  const hash = hashCode(name);
  const colorIndex = hash % colors.length;
  return colors[colorIndex];
}


export function mapSublocalityToColor(name: string) {
  const hash = hashCode(name);
  const colorIndex = hash % sublocalityColors.length;
  return sublocalityColors[colorIndex];
}

/*
 * There is deliberately no mapTherapyToColor here any more. Therapy colours
 * are backend reference data (GetTherapyColors, 12h cache) keyed by
 * TherapyMethod id and PrescribedTherapy id — use `useTherapyColorMap()` with
 * `therapyColorKey(slot)`. No synchronous equivalent exists on purpose, so no
 * caller can quietly reintroduce a hardcoded palette, and nothing keys a
 * colour off an abbreviation (MD-232).
 */


function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
  }
  return Math.abs(hash);
}
